module.exports = __webpack_public_path__ + "files/b6546a34104443ae01b3d8487020be75.ttf";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/robotoslab-bold-webfont.ttf
// module id = 767
// module chunks = 60